import React from "react";
import { Layout } from "@flogy/gatsby-theme-fgs-layout";
import PageSeo from "../components/data-privacy/page-seo";
import IntroText from "../components/data-privacy/intro-text";
import FeatureList from "../components/data-privacy/feature-list";
import OutroText from "../components/data-privacy/outro-text";

const DataPrivacyPage = () => {
  return (
    <>
      <PageSeo />
      <Layout>
        <IntroText />
        <FeatureList />
        <OutroText />
      </Layout>
    </>
  );
};

export default DataPrivacyPage;
